import React, { useEffect, useRef, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { Button, Menu, Segment } from 'semantic-ui-react';
import { useStore } from '../../app/stores/store';
import LoadingComponent, { ThreeDotLoader } from '../../app/layout/LoadingComponent';
import { v4 as uuid } from 'uuid';
import DynamicTableComponent from '../DynamicTable/DynamicTableComponent';
import {
  CRM_Metadata,
  templateL2Info,
} from '../../app/stores/CRMStore/types';
import Components from '../../app/common/components';
import Authorization from './Authorization';
import Logistics from './Logistics';
const CRM_SmartFlow = () => {
  const {
    CRMStore: {
      handleSmartFlowTemplate,
      SubtaskGroupDetails,
      loader,
      showButton,
      handleStatusUpdate,
      titileInformation,
      handleTableDetails,
      subtaskCompoent,
      buttonShowHandler,  
      activePage,
    },
    CRMStore,
    commonStore,
    dashboardStore,
  } = useStore();
  const { Start, Complete } = showButton;
  const [subTaskDetails, setSubTaskDetails] = useState<
    {
      subtask: string;
      count: number;
    }[]
  >([]);
  const [selectedSubtask, setSelectedSubtask] = useState<string>('');
  const [pageNumber, setPageNumber] = useState(1);
  const [errorMessage, setErrorMessage] = useState<any>({});
  const mandatoryFieldsRef = useRef<any>({});
  useEffect(() => {
 if(activePage === 'Process'){
   handleSmartFlowTemplate();
   setPageNumber(1);
 }   
    // eslint-disable-next-line
  }, [activePage]);
  useEffect(()=>{
   if(commonStore.filterModeOne.length === 0) return
    const currentPage = templateL2Info.filter((e)=> commonStore.filterModeOne?.includes(e.roleId))
    CRMStore.activePage = currentPage?.[0]?.task || '';
    // eslint-disable-next-line
  },[commonStore.filterModeOne])
  useEffect(() => {
    if (SubtaskGroupDetails.length === 0 || activePage !== 'Process') return;
    const transformedDetails = SubtaskGroupDetails.map((detail) => ({
      subtask: detail.subtask,
      count: detail.count,
    }));
    setSubTaskDetails(transformedDetails);
    const selectedSubTask = SubtaskGroupDetails.filter((s) => s.count !== 0);
    setSelectedSubtask(selectedSubTask?.[0]?.subtask || 'Physical Inspection');
    handleTableDetails(
      1,
      'Film Digitization Workflow',
      selectedSubTask?.[0]?.subtask  || 'Physical Inspection'

    );
    // eslint-disable-next-line
  }, [SubtaskGroupDetails]);
  const paginateFunction = (e: number) => {
    handleTableDetails(
      e,
      'Film Digitization Workflow',
      selectedSubtask,
    );
    dashboardStore.setTagPageNumFunc(e);
    setPageNumber(e);
  };
  useEffect(() => {
    if (dashboardStore.dashboard.setTagTablePageNumber === 1) {
      setPageNumber(dashboardStore.dashboard.setTagTablePageNumber);
    }
    // eslint-disable-next-line
  }, [dashboardStore.dashboard.setTagTablePageNumber]);
  const searchFunction = (column: any, order: any) => {
    console.log(order, column);
  };
  const onChangeHandler = (
    e: any,
    { value }: { value: string },
    elements: CRM_Metadata,
  ) => {
    let result = '';
    let errorTemp = Object.assign({}, errorMessage);
    const localElement = [...subtaskCompoent.elements];
    const index = localElement.findIndex(
      (x) => x.elementName === elements.elementName,
    );

    Array.isArray(value)
      ? (value = value.join(',').replace(/,/g, '|'))
      : (value = /datepicker/gi.test(elements?.elementType || '')
          ? e?.toLocaleDateString('en-GB')
          : elements?.elementType === 'DateTime'
            ? new Date(value).toDateString() +
              ' ' +
              new Date(value).toString().split(' ')[4]
            : value);

    localElement[index].elementValue = value;

    // validation

    if (/textbox/gi.test(elements?.elementType || '')) {
      result = commonStore.genericValidation(
        value || '',
        elements?.validation || '',
      );
    }
    if (elements?.isMandatory && !value?.length) {
      result = 'This is mandatory field';
    }

    if (result) {
      errorTemp[`${elements?.elementId}`] = result;
      mandatoryFieldsRef.current[`${elements?.elementId}`] =
        elements?.elementId;
    } else {
      delete errorTemp[`${elements?.elementId}`];
      delete mandatoryFieldsRef.current[`${elements?.elementId}`];
    }
    setErrorMessage(errorTemp);

    subtaskCompoent.elements = localElement
  };
  return (
    <div>
      {dashboardStore.dashboard.loadingdata === 'loading' || 
      // eslint-disable-next-line
     loader.tableLoader ? <LoadingComponent/> : <></>}
   {/* // eslint-disable-next-line */}
   <div className="newProductionPlanning-wrapper">
          <div>
            {templateL2Info?.length !== 0 && (
              <Menu
                style={{
                  padding: '5px',
                  height: '47px',
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    gap: '10px',
                    flexWrap: 'wrap',
                  }}
                >
                    {templateL2Info
                    .filter((e)=> !commonStore.filterModeZero?.includes(e.roleId))
                    .map(({ task, roleId }) => (
                      <button
                        style={{ height: '10px' }}
                        onClick={()=>{
                          CRMStore.activePage = task;
                        CRMStore.handleAuthorizationModel();
                      }}
                        className={
                          commonStore.filterModeZero?.includes(roleId)
                            ? 'disabled'
                            : activePage === task
                              ? 'selected'
                              : ''
                        }
                        disabled={commonStore.filterModeZero?.includes(roleId)}
                      >{task}</button>
                    ))}
                </div>
              </Menu>
            )}
          </div>
        </div>
        {activePage === 'Authorization' ? 
        <Authorization /> :
        activePage === 'Logistics' ?
        <Logistics/> :
        activePage === 'Process' ? <> 
     <Segment style={{display:'flex',justifyContent:'space-between'}}>
        <div className="newProductionPlanning-wrapper">
          <div>
            {subTaskDetails?.length !== 0 && (
              <Menu
                style={{
                  padding: '5px',
                  height: '47px',
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    gap: '10px',
                    flexWrap: 'wrap',
                  }}
                >
                  {!subTaskDetails?.length ? (
                    <h4>Sorry No Data</h4>
                  ) : (
                    subTaskDetails.map(({ subtask, count }) => (
                      <button
                        style={{ height: '10px' }}
                        onClick={() => {
                          setPageNumber(1)
                          setSelectedSubtask(subtask);
                          buttonShowHandler();
                          CRMStore.authorizationModel = true
                          subtaskCompoent.isModel = false
                          handleTableDetails(
                            1,
                            'Film Digitization Workflow',
                            subtask,
                          );
                        }}
                        className={
                          count === 0
                            ? 'disabled'
                            : selectedSubtask === subtask
                              ? 'selected'
                              : ''
                        }
                        disabled={count === 0}
                      >{`${subtask} (${count})`}</button>
                    ))
                  )}
                </div>
              </Menu>
            )}
          </div>
        </div>
        <div>  {Start || Complete  ? (
              <>
                {loader.buttonLoader ? (
                  <div
                    style={{
                      position: 'relative',
                      width: '40px',
                      height: '48px',
                    }}
                  >
                    <ThreeDotLoader />
                  </div>
                ) : (
                  <>
                    {showButton.Start && (
                      <Button
                        onClick={() =>
                          handleStatusUpdate('Start', 1, subtaskCompoent.elements,pageNumber,selectedSubtask)
                        }
                        color="blue"
                      >
                        Start
                      </Button>
                    )}
                    {showButton.Complete && (
                      <Button.Group floated="right">
                        <Button
                          color="green"
                          onClick={() =>
                            handleStatusUpdate('Complete', 2, subtaskCompoent.elements,pageNumber,selectedSubtask)
                          }
                        >
                          {' '}
                          Complete{' '}
                        </Button>
                      </Button.Group>
                    )}
                  </>
                )}
              </>
            ) : null}</div>
      </Segment>
        {selectedSubtask === 'Authorization' ?
        <Authorization/> :
        <DynamicTableComponent
          key={uuid()}
          data={titileInformation}
          name={`CRM ${selectedSubtask}`}
          actiontype={''}
          pageFunc={paginateFunction}
          pageNumData={pageNumber}
          searchFuncData={searchFunction}
        />}
      {CRMStore.subtaskCompoent.isModel ? (
        <Segment>
          <div style={{marginLeft:'25%'}}>
          {subtaskCompoent.elements?.filter(() => {
            return true;
          })
            ?.sort((a, b) => {
              if (a.elementIndex < b.elementIndex) return -1;
              if (a.elementIndex > b.elementIndex) return 1;
              return 0;
            })
            ?.map((elem: any, index: number) => {
              return (
                <>
                  <Components
                    elementDetails={elem}
                    disabled={commonStore.filterModeZero?.includes(
                      elem.templateElementId,
                    )}
                    index={index}
                    templateId={elem.templateElementId || ''}
                    onChangeHandler={onChangeHandler}
                    errorMessage={errorMessage}
                    RoleChecker={false}
                    onPhotoClick={() => {}}
                    getUploadedFiles={() => {}}
                    onConfirmUser={() => {}}
                    name={'CRM SmartFlow'}
                  />
                </>
              );
            })}
          </div>
        </Segment>
      ) : null} </> : null}
    </div>
  );
};

export default observer(CRM_SmartFlow);
